<template>
    <span class="rounded-full px-2 py-1 text-lg xl:px-4 xl:py-2">
        <slot></slot>
    </span>
</template>
